import { createFileRoute } from '@tanstack/react-router'

import { FeatureNotAvailable } from '@/components/feature-not-available'

export const Route = createFileRoute('/_authenticated/_general/marketing/messaging')({
	component: MessagingPage,
	staticData: {
		crumb: ({ context: { L } }) => L.Marketing.Messaging()
	}
})

function MessagingPage() {
	return <FeatureNotAvailable />
}
